import { usePublicSiteContent } from '@repo/ui/hooks/api/site-content';
import { AboutSection } from '../../components/home/about-section';
import { ContactSection } from '../../components/home/contact-section';
import { DendromapMarketingSection } from '../../components/home/dendromap-marketing-section';
import { Footer } from '../../components/home/Footer';
import { Header } from '../../components/home/header';
import { HeroSection } from '../../components/home/hero-section';
import { PricingSection } from '../../components/home/pricing-section';
import { ProductHighlightsSection } from '../../components/home/product-highlights-section';
import { ScreenshotsSection } from '../../components/home/screenshots-section';
import { ServiceDetailsSection } from '../../components/home/service-details-section';
import { SolutionsSection } from '../../components/home/solutions-section';
import { TestimonialsSection } from '../../components/home/testimonials-section';

export default function HomePage() {
  const { data: content, isLoading } = usePublicSiteContent();

  // Content is already in the format we need (Record<string, string>)
  const websiteContent = content || {};

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <HeroSection content={websiteContent} />
      <SolutionsSection content={websiteContent} />
      <ProductHighlightsSection />
      <AboutSection content={websiteContent} />
      <DendromapMarketingSection />
      <ServiceDetailsSection content={websiteContent} />
      <ScreenshotsSection content={websiteContent} />
      <PricingSection content={websiteContent} />
      <ContactSection content={websiteContent} />
      <Footer />
    </div>
  );
}
